// Facebook Pixel + Conversions API client-side helper
// Handles browser pixel events with deduplication IDs for server-side matching

const FB_PIXEL_ID = "1313080617410759";
let initialized = false;

// Generate unique event ID for deduplication between pixel and CAPI
export const generateEventId = () =>
  `evt_${Date.now()}_${Math.random().toString(36).slice(2, 9)}`;

// Initialize Facebook Pixel (call once on app load)
export const initFBPixel = () => {
  if (initialized || typeof window === "undefined") return;
  try {
    /* eslint-disable */
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    /* eslint-enable */
    window.fbq("init", FB_PIXEL_ID);
    window.fbq("track", "PageView");
    initialized = true;
  } catch (e) {
    // Silently fail
  }
};

// Track standard pixel event (client-side)
export const fbTrack = (eventName, params = {}, eventId) => {
  try {
    if (typeof window !== "undefined" && window.fbq) {
      const opts = eventId ? { eventID: eventId } : {};
      window.fbq("track", eventName, params, opts);
    }
  } catch (e) {
    // Silently fail
  }
};

// Track custom pixel event (client-side)
export const fbTrackCustom = (eventName, params = {}, eventId) => {
  try {
    if (typeof window !== "undefined" && window.fbq) {
      const opts = eventId ? { eventID: eventId } : {};
      window.fbq("trackCustom", eventName, params, opts);
    }
  } catch (e) {
    // Silently fail
  }
};

// Send server-side event via Conversions API (through our backend proxy)
export const fbServerEvent = async (eventName, params = {}, eventId, userData = {}) => {
  try {
    const eid = eventId || generateEventId();
    await fetch("/api/fb/event", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({
        event_name: eventName,
        event_id: eid,
        event_source_url: window.location.href,
        custom_data: params,
        user_data: userData,
      }),
    });
    return eid;
  } catch (e) {
    // Silently fail
    return null;
  }
};

// Combined: fire both pixel + CAPI for maximum attribution
export const fbTrackDual = (eventName, params = {}, userData = {}) => {
  const eid = generateEventId();
  fbTrack(eventName, params, eid);
  fbServerEvent(eventName, params, eid, userData);
  return eid;
};

// ─── Pre-built event helpers ───

export const fbPageView = () => {
  const eid = generateEventId();
  fbTrack("PageView", {}, eid);
  fbServerEvent("PageView", {}, eid);
};

export const fbViewContent = (contentName, contentCategory) => {
  fbTrackDual("ViewContent", {
    content_name: contentName,
    content_category: contentCategory,
  });
};

export const fbCompleteRegistration = (method) => {
  fbTrackDual("CompleteRegistration", {
    content_name: method || "google_oauth",
    value: 0,
    currency: "USD",
  });
};

export const fbOnboardedUser = () => {
  fbTrackCustom("OnboardedUser", {
    content_name: "onboarding_complete",
  });
};
